<template>
    <share-entity-dialog ref="base" collection="questionnaires" :title="$t('questionnaires.share_questionnaire')"
        :shared-toast="$t('questionnaires.shared')" />
</template>

<script>
import ShareEntityDialog from "./ShareEntityDialog";

export default {
    name: "ShareQuestionnaireDialog",
    components: { ShareEntityDialog },
    methods: {
        show(entity) {
            this.$refs.base.show(entity)
        },
    }
}
</script>
